import { FC, useState } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import styled from './index.module.scss';
import CheckedIcon from './Icon';
import Emarsys from '@/components/MembersDay/FY2024/Emarsys';
import { EU_SITES, currentEmailSource, zaNewProductSource, euEmailSource } from '@/constants/membersday';
import getLocal from '@/app/utils/getLocal';
import gtm from '@/utils/gtm';
import { useLang } from '@/i18n';
import { getPrivacyPolicy } from '@/utils/common';

const hasCheckBoxLocal = ['za', 'au', 'kr'];
interface IProps {
    newProductSub?: boolean; // 新品订阅
}

const SubscribeNewProduct: FC<IProps> = ({ newProductSub }) => {
    const { locale } = getLocal();
    const { t } = useLang('membersday.subscribeNewProd');
    const [checked, setChecked] = useState(locale === 'za' ? false : true);
    // source字段
    let source = currentEmailSource;
    if (EU_SITES.includes(locale)) source = euEmailSource.teaser;
    if (newProductSub && locale === 'za') source = zaNewProductSource;
    if (locale === 'au') source = zaNewProductSource;

    const successCallBack = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('btnText'),
                status: 'success',
                tag: 'Agree',
            });
        } catch (e) {
            console.error(e);
        }
    };

    const errorCallback = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_submit',
            button_name: t('btnText'),
            status: 'fail',
            tag: 'Agree',
        });
    };

    return (
        <div className={`${styled.SubscribeNewProduct} ${newProductSub ? 'product_sub' : ''}`}>
            <EditorImg
                pc={'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1712130382778/PC_fast_charging_while_driving.jpg'}
                h5={'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1712130466333/MO_fast_charging_while_driving.jpg'}
            />

            <div className="subscribe_box">
                <div className="desc-content">
                    <div className="top-title">{t('toptitle')}</div>
                    <h5 className="subscribe_title">{t('title')}</h5>
                    <div className="sub-title">{t('subtitle')}</div>
                    <div className="sign-up-tips">{t('signUpTips')}</div>
                </div>
                <div className="email-box">
                    <Emarsys
                        source={source}
                        submitText={t('btnText')}
                        placeholder={t('placeholder')}
                        successCallback={successCallBack}
                        errorCallback={errorCallback}
                        checked={checked}
                    />
                    <p className="protocol">
                        {hasCheckBoxLocal.includes(locale) && (
                            <span className={`check ${checked && 'checked'}`} onClick={() => setChecked(!checked)}>
                                {checked && <CheckedIcon />}
                            </span>
                        )}
                        {t.rich('protocol', {
                            line1: (text: string) => (
                                <a className="link" href={getPrivacyPolicy(locale)} target="_blank" rel="noreferrer">
                                    {text}
                                </a>
                            ),
                            line2: (text: string) => (
                                <a className="link" href={`https://${locale}.ecoflow.com/policies/terms-of-service`} target="_blank" rel="noreferrer">
                                    {text}
                                </a>
                            ),
                        })}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default SubscribeNewProduct;
